import type { CompanionSnapshot } from "../companion/store.ts";
import type { CompanionView } from "./store.ts";

/**
 * The Companions tab's view of the server's `companionState` (P2.26-T6, P2.26-T24): one companion, the Aethling (kind 1,
 * the only kind the frame names yet; P2.26-T25 adds the kind to the frame), once he has joined; none before. The bond
 * and today's feed state reach the page with the bond branch (tier and pips, the exact bar only with Animal Lore), so
 * both are unknown here and the tab draws neither.
 */

/**
 * The companion id and kind the frame implies while it names neither.
 */
const AETHLING = 1;

/**
 * The tab's companions for a `companionState`.
 *
 * @param state What the server last said of the companion.
 * @returns The companions, empty before one has joined.
 */
export function companionViews(state: CompanionSnapshot): CompanionView[] {
  return state.joined ? [{ id: AETHLING, kind: AETHLING, name: state.name, out: state.out, bond: null, fed: null }] : [];
}
